import { useState } from 'react';
import { Box, Typography, Container } from '@mui/material';

import CourtSelection from './CourtSelection';
import DatePickerComponent from './DatePickerComponent';
import TimeSlots from './TimeSlots';
import BookingConfirmation from './BookingConfirmation';

const Content = () => {
  const [court, setCourt] = useState(null);
  const [date, setDate] = useState(null);
  const [bookingDetails, setBookingDetails] = useState(null); // Store final booking details

  const handleCourtSelect = (selectedCourt) => setCourt(selectedCourt);
  const handleDateSelect = (selectedDate) => setDate(selectedDate);

  const handleSlotSelect = (details) => {
    setBookingDetails({ ...details, court, date }); // Combine with court and date
  };

  const handleBackToCourtSelection = () => {
    setCourt(null);
    setDate(null);
    setBookingDetails(null);
  };

  const handleBackToDateSelection = () => {
    setDate(null);
    setBookingDetails(null);
  };

  return (
    <Box sx={{ flex: 1, p: 1, pt: 0, backgroundColor: '#1f2937'}}>
      <Container maxWidth="md">
        <Typography variant="body1" color="#e5e7eb" textAlign="center">
          {!court && <CourtSelection onSelectCourt={handleCourtSelect} />}
          {court && !date && (
            <DatePickerComponent onDateSelect={handleDateSelect} onBack={handleBackToCourtSelection}/>
          )}
          {court && date && !bookingDetails && (
            <TimeSlots
              court={court} date={date} onSlotSelect={handleSlotSelect} onBack={handleBackToDateSelection}
            />
          )}
          {bookingDetails && (
            <BookingConfirmation bookingDetails={bookingDetails} />
          )}
        </Typography>
      </Container>
    </Box>
  );
};

export default Content;
